import { Row } from 'antd';
import close from './close-circle-fill.png';
const IconClose = () => (
    <Row>
        <img src={close} style={{ height: '100%', width: '100%' }} />
    </Row>
);

export default IconClose;
